import { yupHelper } from "lib/helpers";
import constant from "lib/constant/constant";

import {
  accountNumberSchema,
  accessLicenseNumberSchema,
  accessSchema,
  addressSchema,
  citySchema,
  clientIdSchema,
  clientSecretSchema,
  contactSchema,
  countrySchema,
  customerSchema,
  passwordSchema,
  pincodeSchema,
  siteCodeSchema,
  shippingRateSchema,
  userSchema,
  vendorSchema,
  apiSchema,
} from "./schema";

const validate = async (field, value, cms) => {
  const { validateValue, handlePromiseError } = yupHelper;
  let promise = "";
  switch (field) {
    case constant.ADDRESS:
      promise = validateValue(addressSchema(cms), { address: value });
      break;
    case constant.ACCOUNT_LICENSE_NUMBER:
      promise = validateValue(accessLicenseNumberSchema(cms), { accessLicenseNumber: value });
      break;
    case constant.CITY:
      promise = validateValue(citySchema(cms), { city: value });
      break;
    case constant.COUNTRY_CODE:
      promise = validateValue(countrySchema(cms), { countryCode: value });
      break;
    case constant.PINCODE:
      promise = validateValue(pincodeSchema(cms), { pincode: value });
      break;
    case constant.VENDOR_IDS:
      promise = validateValue(vendorSchema(cms), { vendorIds: value });
      break;
    case constant.CLIENT_ID:
      promise = validateValue(clientIdSchema(cms), { clientId: value });
      break;
    case constant.CLIENT_SECRET:
      promise = validateValue(clientSecretSchema(cms), { clientSecret: value });
      break;
    case constant.ACCOUNT_NUMBER:
      promise = validateValue(accountNumberSchema(cms), { accountNumber: value });
      break;
    case constant.SITE_CODE:
      promise = validateValue(siteCodeSchema(cms), { siteCode: value });
      break;
    case constant.USER_NAME:
      promise = validateValue(userSchema(cms), { user: value });
      break;
    case constant.PASSWORD:
      promise = validateValue(passwordSchema(cms), { password: value });
      break;
    case constant.CONTRACT_ID:
      promise = validateValue(contactSchema(cms), { contact: value });
      break;
    case constant.CUSTOMER_NUMBER:
      promise = validateValue(customerSchema(cms), { customer: value });
      break;
    case constant.API_KEY:
      promise = validateValue(apiSchema(cms), { apiKey: value });
      break;
    case constant.ACCESS_KEY:
      promise = validateValue(accessSchema(cms), { accessKey: value });
      break;
    case constant.CUSTOM_RATE_NAME:
      promise = validateValue(shippingRateSchema(cms), { shippingRateName: value });
      break;
    default:
      return "";
  }
  return handlePromiseError(promise);
};

export default validate;
